import type { Feature } from 'geojson';
import allNetherlandsFeature from '../../presets/allNetherlands';
import { v4 as uuidv4 } from 'uuid';
import { assertNever } from '~/util/assertion';

export type PresetId = 'Netherlands';

export type AddPresetFunction = ({
  preset,
  workingAreaType,
}: {
  preset: PresetId;
  workingAreaType: { inclusive: true } | { exclusive: true };
}) => void;

type Args = {
  preset: PresetId;
  officeId: string;
  workingAreaType: { inclusive: true } | { exclusive: true };
};

/**
 * Creates a GeoJSON Feature for a preset working area based on the specified preset type.
 *
 * @param {PresetId} args.preset - The preset identifier (e.g., 'Netherlands')
 * @param {string} args.officeId - The unique identifier for the office
 * @returns {Feature} A GeoJSON Feature object with preset coordinates and properties
 *
 * @keywords workingarea, preset, coordinates, feature, inclusive, exclusive
 */
const getPreset = ({ preset, officeId, workingAreaType }: Args): Feature => {
  switch (preset) {
    case 'Netherlands': {
      const netherlandsFeature: Feature = {
        ...allNetherlandsFeature,
        id: `${officeId}-${uuidv4()}`,
        properties: {
          ...allNetherlandsFeature.properties,
          ...workingAreaType,
        },
      };

      return netherlandsFeature;
    }

    default: {
      return assertNever(preset);
    }
  }
};
export default getPreset;
